import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { DRulesComponent } from 'src/app/@shared/components/rules/d-rules/d-rules.component';
import { MRulesComponent } from 'src/app/@shared/components/rules/m-rules/m-rules.component';
import { RulesComponent } from 'src/app/@shared/components/rules/rules.component';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { MLoginComponent } from 'src/app/auth/login/m-login/m-login.component';
import { DLoginComponent } from 'src/app/auth/login/d-login/d-login.component';
import Swal from 'sweetalert2';
import { RulesPageComponent } from 'src/app/pages/rules-page/rules-page.component';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})
export class TopnavComponent extends BaseClass<any> implements OnInit {
  @ViewChild('afterLoginModal', { static: false }) afterLoginModal?: ModalDirective;
  openafterLoginModal = false;
  modalRef?: BsModalRef;
  searchStatus: boolean = false;
  downloadDivStatus: boolean = true;
  selected?: string;
  searchData: any[] = [];
  public _pusher!: PusherService;
  public balInfo: any = {
    wall_amt: 0,
    net_expo: 0,
    bous: 0,
    avail_withdrawal: 0,
    await_bonus: 0
  }

  constructor(public service: WebserviceService,
    public router: Router,
    public _message: MessageService,
    public _shared: SharedService,
    public _common: CommonService,
    private injector: Injector,
    private modalService: BsModalService
  ) {
    super(document);

    this.downloadDivStatus = (this.getLocalItem('dwnApk')) ? false : true;

    this._shared.sharedLogin.subscribe(data => {
      this.userData = this.getLocalItem('user');
      // if (data && this.userData?.username.toLowerCase() != 'demo123' && this.env.host.domain == '1xbetfair.com')
      if (data && this.userData?.username.toLowerCase() != 'demo123' && this.env.host.afterLoginNoticePath != '')
        this.showAfterLoginModal();
    });

    this.setBalanceInfo();
    if (this.isLogin()) {
      // this.userData.expose = Math.abs(this.userData.expose);

      this._pusher = injector.get<PusherService>(PusherService);
      this._pusher.userAccUpdate().subscribe(res => {
        if (res) {
          if (res.msg != '') {
            this._message.errmessage(res.msg);
            setTimeout(() => {
              this.removeLocalStorage();
              this.router.navigate([`${this.env.isMobile ? '/m/home' : '/home'}`]);
              window.location.reload();
            }, 1000)
          }

          if (res?.op == 'R') {
            this._shared.emitUpdateUserAccPusher(res);
          }
          this.userData.balance = parseFloat(res?.balance) + parseFloat(res?.expose) + parseFloat(res?.pl);
          this.userData.available_balance = parseFloat(res?.balance) + parseFloat(res?.expose) + parseFloat(res?.pl);
          this.userData.expose = res?.expose;
          this.setLocalItem('user', this.userData);
          this.setBalanceInfo();
        }
      });
    }


  }

  showAfterLoginModal() {
    if (localStorage.getItem(`${this.env.panel}JustL`)) {
      this.afterLoginModal?.show();
      this.openafterLoginModal = true;
      localStorage.removeItem(`${this.env.panel}JustL`);
    } else {
      console.log('out');
      this.openafterLoginModal = false;
    }
  }

  setBalanceInfo() {
    if (this.userData != null) {
      this.balInfo.wall_amt = this.decimalFixed(this.userData?.available_balance);
      this.balInfo.net_expo = this.decimalFixed(this.userData?.expose);
      this.balInfo.bonus = (this.userData?.pl < 0)
        ? this.decimalFixed(parseFloat(this.userData?.balance) + parseFloat(this.userData?.pl))
        : this.decimalFixed(this.userData?.balance);
      this.balInfo.avail_withdrawal = (this.userData?.pl < 0)
        ? 0.00
        : this.decimalFixed(parseFloat(this.userData?.pl) - parseFloat(this.userData?.expose));
      this.balInfo.await_bonus = this.userData?.bonus_amount ? this.userData?.bonus_amount : 0;
    }
  }

  ngOnInit(): void {
    // if (this.getLocalItem('JustL')) {
    //   this.openafterLoginModal = true;
    //   localStorage.removeItem(`${this.env.panel}JustL`);
    // } else {
    //   this.openafterLoginModal = false;
    // }
    if (this.isLogin()) {
      this.isChatIn = true;
      this.getContactInfo();
    }
    this.menu = this.getLocalItem('menu') ? this.getLocalItem('menu', true) : [];
    if (this.menu.length == 0) { this.getMenu(); }
    this.genSearchList();

  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  handleroute(url: any) {
    if (this.isLogin()) {
      let pagesUrl: any[] = ['/sports', '/game-list/', '/reports/account-statement', '/home', '/dashboard', '/game-detail'];
      pagesUrl.forEach(element => {
        if (url.startsWith(element)) {
          this.getUserData();
        }
      });

    }
  }

  getUserData() {
    if (this.isLogin()) {
      this.userData = this.getLocalItem('user');
      this.webSocketUrl = this.getLocalItem('ws', false);
      if (this.webSocketUrl) {
        this.getServices().Get(`${this.webSocketUrl + this.api.userData}/${this.userData?.id}`).subscribe(
          (res) => {
            if (res) {
              this.userData.balance = res.balance;
              this.userData.pl = res.pl;
              this.userData.available_balance = parseFloat(res.pl) + parseFloat(res.balance) + parseFloat(res.expose);
              this.userData.expose = res.expose;
              this.setLocalItem('user', this.userData);
              this.userData = this.getLocalItem('user');
            }
          },
          (err) => {
            console.log(err);
          });
      }
    }
  }

  getMenu() {
    this.getServices().Get(`${this.env.baseUrl + this.api.menu}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (!this.getLocalItem('stakes')) {
            localStorage.removeItem(`${this.env.panel}stakes`);
            this.setLocalItem('stakes', this.env.stakes)
          }
          localStorage.removeItem(`${this.env.panel}menu`);
          this.setLocalItem('menu', res?.data?.menu)
          this.menu = res?.data?.menu;
          this._shared.emitSideMenu('');
          this._shared.emitMenu({ key: 'emitMenu' });
        }
      },
      (err) => {
        console.log(err);
      });
  }

  confirmBoxSportBook(item: any) {
    if (this.isLogin()) {
      let multiplier = localStorage.getItem(`${this.env.panel}sb_multiplier`);
      let msg = `Profit & Loss in Sportsbook would be ${multiplier} times.It means, if you WIN 1, your Account Statement would be Credited as ${multiplier} and similarly if you LOSE 1, your Account Statement would be Debited as ${multiplier}. <br> Please note(1 Point = ${multiplier} Points) <br> कृपया ध्यान दें(1 अंक = ${multiplier} अंक)`;
      Swal.fire({
        title: 'DO YOU AGREE?',
        html: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I Agree',
        cancelButtonText: 'No, I dont Agree'
      }).then((result) => {
        if (result.value) {
          this.router.navigate(['/sports-book']);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.router.navigate(['/home']);
        }
      })
      this.router.navigate(['/home']);
    } else {
      this._common.openLogin();
    }
  }

  logOut() {
    this.getServices().Get(`${this.env.baseUrl + this.api.logout}`).subscribe(
      (res) => {

        this.removeLocalStorage();
        this.router.navigate([`${this.env.isMobile ? '/m/home' : '/home'}`]);
        // this.getMenu();
        // this._message.succmessage(res.message);
        // window.location.reload();
        setTimeout(() => {
          window.location.reload();
        }, 200)
      },
      (err) => {
        console.log(err);
      });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'full-width-modal' });
  }

  openSignUpModal() {
    this._common.openModalWithComponent({ signUpModal: true }, this.env.isMobile ? MLoginComponent : DLoginComponent, 'full-width-modal')
  }

  openBonusRule() {
    this._common.openModalWithComponent({ bonus: true }, RulesPageComponent, 'bonus-rule')
  }

  bsModalRef!: BsModalRef;
  openModalWithComponent() {
    this.bsModalRef = this.modalService.show(DRulesComponent, {
      class: 'modal-full'
    });
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  redirectDetail(e: any) {
    this.selected = ''
    // this._router.navigate(['/event/detail', e.event_id])
  }

  ngAfterContentChecked() {
    this.genSearchList();
    this.userData = this.getLocalItem('user');
  }

  genSearchList() {
    let tempData: any[] = [];
    tempData = [...tempData, ...this.getLocalItem('sideMenu') ? this.getLocalItem('sideMenu') : []];
    // let race7 = (this.getLocalItem('sideRaceMenu7')) ? this.getLocalItem('sideRaceMenu7') : [];
    // race7.forEach((element: any) => {
    //   element['name'] = element?.event_name;
    // });
    // let race4339 = (this.getLocalItem('sideRaceMenu4339')) ? this.getLocalItem('sideRaceMenu4339') : [];
    // race4339.forEach((element: any) => {
    //   element['name'] = element?.event_name;
    // });
    // tempData = [...tempData, ...race7];
    // tempData = [...tempData, ...race4339];

    this.searchData = tempData;
    // console.log(this.searchData);

  }

  redirectHome() {
    this._shared.emitTabSet({ mode: 'home' })
  }

  public wpLink = '';
  isChatIn: boolean = false;
  getContactInfo() {
    this.userData = this.getLocalItem('user');
    if (this.userData.username.toLowerCase() == this.env.demoLoginUserName) {
      this.wpLink = this.env.host.social.wpLink != '' ? this.env.host.social.wpLink : this.wpLink;
      this.env.demoDWLink = this.env.host.social.wpLink != '' ? this.env.host.social.wpLink : this.env.demoDWLink;
      this.contactInfoApi('demo');
    } else {
      if (this.depoWithdrawCondition()) {
        // let url = `https://reddypanel.com/contact/reddybook.club/358417/Jnq8MNgo9g5R2SCDf8d35db89cdcdfc9d975bd67e0309d22`; //testURL
        this.contactInfoApi('');
      }
    }
  }
  contactInfoApi(key: any) {
    if (this.userData.contact_info != '') {
      let url = this.userData.contact_info.replace(':domain', this.env.host.domain);
      this.getServices().Get(url).subscribe(
        (res) => {
          if (res?.error == 0) {
            if (key == 'demo') {
              this.wpLink = this.env.host.social.wpLink != '' ? this.env.host.social.wpLink : res?.link;
            } else {
              this.wpLink = res?.link;
            }
            this.env.demoDWLink = this.env.host.social.wpLink != '' ? this.env.host.social.wpLink : res?.link;
          }
        },
        (err) => {
          console.log(err);
        });
    }
  }

  hideDwnApk() {
    this.downloadDivStatus = false;
    this.setLocalItem('dwnApk', 1);
  }

  ngDoCheck() {
    this.userData = this.getLocalItem('user');
    this.menu = this.getLocalItem('menu') ? this.getLocalItem('menu', true) : [];
    this.setBalanceInfo();
    // if (this.menu.length == 0) { this.getMenu(); }
    if (this.isChatIn == false && this.isLogin()) {
      this.isChatIn = true;
      this.getContactInfo();
    }
  }


}
